/**
 * 
 * @param {string | number} year formato YYYY
 * @param {string | number} month formato MM 
 * @returns {Object} - Retorna objeto con las fechas de inicio y fin del mes
 */
export default function getStartAndEndDateByYearAndMonth(year, month) {
    const startDate = moment({ year, month: month - 1 })
        .startOf("month")
        .format("YYYY-MM-DD")
    const endDate = moment({ year, month: month - 1 })
        .endOf("month")
        .format("YYYY-MM-DD")
    return { startDate, endDate }
}